import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryLegend,
  VictoryLine,
  VictoryScatter,
  VictoryTheme, VictoryGroup,
} from 'victory'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../../utils/global'

class TrackerSampleChart2 extends Component {
  constructor(props) {
    super(props)

    this.state = {
      checked: false,
      graph_config_status: 1,
      graph_type: 1,
      graph_data_show: 1,
      tracker_timeback: 1,
      tracker_day: [],
      tracker_week: [],
    }
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    var get_tracker_day = []
    var get_tracker_week = []
    // tracker day //
    this.setState({
      tracker_day: this.getSampleData1(),
      //tracker_week: get_tracker_week,
    })
    /*axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/get_tracker_by_type3',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: this.props.match.params.pid,
        type: 1,
        tracker_timeback: this.state.tracker_timeback,
      }
    })
    .then((result) => {
      if(result['data'].length > 0) {
        get_tracker_day = result['data']
        this.setState({
          tracker_day: get_tracker_day,
        })
      }
    })
    // tracker week //
    axios({
      method: 'post',
      url: connectNode + 'admin/patient_assessment/get_tracker_by_type3',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        uid: this.props.authReducer.uid,
        pid: this.props.match.params.pid,
        type: 2,
        tracker_timeback: this.state.tracker_timeback,
      }
    })
    .then((result) => {
      if(result['data'].length > 0) {
        get_tracker_week = result['data']
        this.setState({
          tracker_week: get_tracker_week,
        })
      }
    })

    console.log(this.state)*/
  }

  normalizeValue = (value, originalMin, originalMax) => {
    if ( value === null || value === undefined || value === '' || Number(value) < originalMin ) {
      return null
    }
    const normalized = 1 + ((Number(value) - originalMin) * 4) / (originalMax - originalMin)
    return Math.round(normalized * 100) / 100
  }

  parseDate = value => {
    if (!value) {
      return null
    }

    // For API dates such as 2026-08-09T00:00:00
    if (value.indexOf('-') !== -1) {
      const datePart = value.split('T')[0]
      const parts = datePart.split('-')

      return new Date(
        Number(parts[0]),
        Number(parts[1]) - 1,
        Number(parts[2])
      )
    }

    // For sample dates such as 09/08/26
    const parts = value.split('/')

    return new Date(
      2000 + Number(parts[2]),
      Number(parts[1]) - 1,
      Number(parts[0])
    )
  }

  formatDate = value => {
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) { return '' }
    return `${date.getMonth() + 1}/${date.getDate()}`
  }

  getChartData = () => {
    return this.state.tracker_day
  }

  getLineData = (
    key,
    minimum,
    maximum,
    reverse = false
  ) => {
    return this.getSampleData1().map((item, index) => {
      const originalValue = Number(item[key])

      if (Number.isNaN(originalValue)) {
        return {
          x: index + 1,
          y: null,
        }
      }

      const convertedValue = originalValue //reverse ? minimum + maximum - originalValue : originalValue

      return {
        x: index + 1,
        y: convertedValue,
        date: item.date,
      }
    })
  }

  getDateDomain = () => {
    const dates = this.getChartData()
      .map(row => this.parseDate(row.date))
      .filter(date => {
        return date && !Number.isNaN(date.getTime())
      })

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    if (dates.length === 0) {
      const oneMonthAgo = new Date(today)
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1)

      return [oneMonthAgo, today]
    }

    const firstDate = new Date(
      Math.min(...dates.map(date => date.getTime()))
    )

    return [firstDate, today]
  }

  renderLine = (key, color, min, max, reverse = false) => {
    const data = this.getLineData(key, min, max, reverse)

    return (
      <VictoryGroup
        key={key}
        data={data}
        color={color}
      >
        <VictoryLine
          data={data}
          style={{
            data: {
              stroke: color,
              strokeWidth: 1,
            },
          }}
        />

        <VictoryScatter
          data={data}
          size={1.5}
          style={{
            data: {
              fill: color,
            },
          }}
        />
      </VictoryGroup>
    )
  }

  getXAxisTicks = () => {
    const data = this.getChartData()

    if (data.length === 0) {
      return []
    }

    const maximumLabels = 12

    const interval = Math.max(
      1,
      Math.ceil(
        data.length / maximumLabels
      )
    )

    const ticks = []

    for (
      let index = 0;
      index < data.length;
      index += interval
    ) {
      ticks.push(index)
    }

    const lastIndex = data.length - 1

    if (
      ticks[ticks.length - 1] !==
      lastIndex
    ) {
      ticks.push(lastIndex)
    }

    return ticks
  }

  formatXAxisDate = index => {
    const data = this.getChartData()
    const row = data[index]

    if (!row) {
      return ''
    }

    const date = this.parseDate(row.date)

    if (
      !date ||
      Number.isNaN(date.getTime())
    ) {
      return row.date
    }

    return `${
      date.getMonth() + 1
    }/${date.getDate()}`
  }

  getSampleData1 = () => {
    const sampleData = [
        {
          date: '19/04/26',
          mood_manic: 1,
          mood_depressed: 4.5,
          sleep: 5,
          medication: 5,
          exercise: 2.5,
          anxiety: 2,
        },
        {
          date: '26/04/26',
          mood_manic: 1,
          mood_depressed: 4,
          sleep: 5,
          medication: 5,
          exercise: 3,
          anxiety: 1.5,
        },
        {
          date: '30/04/26',
          mood_manic: 4.5,
          mood_depressed: 1.5,
          sleep: 4.5,
          medication: 5,
          exercise: 1.5,
          anxiety: 1.5,
        },
        {
          date: '04/05/26',
          mood_manic: 4,
          mood_depressed: 1,
          sleep: 4.5,
          medication: 5,
          exercise: 1.5,
          anxiety: 1.5,
        },
        {
          date: '10/05/26',
          mood_manic: 3.5,
          mood_depressed: 1,
          sleep: 4.5,
          medication: 5,
          exercise: 1.5,
          anxiety: 1,
        },
        {
          date: '18/05/26',
          mood_manic: 4,
          mood_depressed: 1,
          sleep: 4,
          medication: 5,
          exercise: 2,
          anxiety: 1.5,
        },
        {
          date: '31/05/26',
          mood_manic: 4.5,
          mood_depressed: 1.5,
          sleep: 5,
          medication: 5,
          exercise: 1.5,
          anxiety: 2.5,
        },
        {
          date: '10/06/26',
          mood_manic: 1,
          mood_depressed: 2,
          sleep: 3.5,
          medication: 5,
          exercise: 1.5,
          anxiety: 3,
        },
        {
          date: '17/06/26',
          mood_manic: 1,
          mood_depressed: 3,
          sleep: 3.5,
          medication: 5,
          exercise: 1.5,
          anxiety: 4,
        },
        {
          date: '25/06/26',
          mood_manic: 1,
          mood_depressed: 1.5,
          sleep: 3,
          medication: 5,
          exercise: 1,
          anxiety: 4,
        },
        {
          date: '02/07/26',
          mood_manic: 1,
          mood_depressed: 3,
          sleep: 4,
          medication: 5,
          exercise: 1,
          anxiety: 2.5,
        },
        {
          date: '19/07/26',
          mood_manic: 1,
          mood_depressed: 1.5,
          sleep: 4,
          medication: 5,
          exercise: 1,
          anxiety: 2,
        },
        {
          date: '23/07/26',
          mood_manic: 1,
          mood_depressed: 1,
          sleep: 3.5,
          medication: 5,
          exercise: 2,
          anxiety: 4.5,
        },
        {
          date: '03/08/26',
          mood_manic: 1,
          mood_depressed: 1,
          sleep: 4,
          medication: 5,
          exercise: 1.5,
          anxiety: 2,
        },
      ]

    return sampleData
  }


  render() {
    const chartData = this.getChartData()

    if (chartData.length === 0) {
      return (
        <div className="small-12 columns">
          Loading tracker data...
        </div>
      )
    }

    const xAxisTicks =
      this.getXAxisTicks()

    return (
      <div className="small-12 columns">
        <div className="title6">Weekly Trackers</div>

        <VictoryChart
          theme={VictoryTheme.material}
          height={150}
          padding={{
            top: 25,
            bottom: 30,
            left: 15,
            right: 20,
          }}
          domain={{
            x: [ 0, Math.max( chartData.length - 1, 1 ), ],
            y: [0.7, 5.3],
          }}
          domainPadding={{
            x: 5,
          }}
        >
          <VictoryLegend
            x={45}
            y={5}
            orientation="horizontal"
            gutter={10}
            style={{
              labels: {
                fontSize: 5,
              },
            }}
            data={[
              {
                name: 'Depressed',
                symbol: {
                  fill: '#7e57c2',
                },
              },
              {
                name: 'Manic',
                symbol: { fill: '#00acc1' },
              },
              {
                name: 'Anxiety',
                symbol: {
                  fill: '#d81b60',
                },
              },
              {
                name: 'Sleep',
                symbol: {
                  fill: '#1e88e5',
                },
              },
              {
                name: 'Medication',
                symbol: {
                  fill: '#43a047',
                },
              },
              {
                name: 'Exercise',
                symbol: {
                  fill: '#fb8c00',
                },
              },
            ]}
          />

          <VictoryAxis
            tickValues={xAxisTicks}
            tickFormat={index =>
              this.formatXAxisDate(index)
            }
            style={{
              axis: {
                stroke: '#cccccc',
              },
              grid: {
                stroke: '#eeeeee',
                strokeDasharray: '4,4',
              },
              ticks: {
                stroke: '#cccccc',
                size: 2,
              },
              tickLabels: {
                fontSize: 6,
                padding: 3,
                angle: -45,
                textAnchor: 'end',
              },
            }}
          />

          <VictoryAxis
            dependentAxis
            tickValues={[
              1,
              2,
              3,
              4,
              5,
            ]}
            tickFormat={value => value}
            label="Relative scale"
            style={{
              axis: {
                stroke: '#cccccc',
              },
              axisLabel: {
                fontSize: 7,
                padding: 38,
              },
              grid: {
                stroke: '#eeeeee',
                strokeDasharray: '4,4',
              },
              ticks: {
                stroke: '#cccccc',
                size: 2,
              },
              tickLabels: {
                fontSize: 6,
                padding: 5,
              },
            }}
          />

          {this.renderLine(
            'mood_depressed',
            '#7e57c2',
            1,
            5
          )}

          {this.renderLine(
            'mood_manic',
            '#00acc1',
            1,
            5,
            true
          )}

          {this.renderLine(
            'anxiety',
            '#d81b60',
            1,
            5
          )}

          {this.renderLine(
            'sleep',
            '#1e88e5',
            1,
            7
          )}

          {this.renderLine(
            'medication',
            '#43a047',
            1,
            5
          )}

          {this.renderLine(
            'exercise',
            '#fb8c00',
            1,
            8
          )}
        </VictoryChart>
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  //console.log('Dashboard STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('Dashboard mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(TrackerSampleChart2)
